import { debounce } from "lodash";
import { useEffect, useRef } from "react";
import { FrameElement } from "@hotwired/turbo";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import Spinner from "~/components/shared/Spinner";
import ViewNotAvailable from "~/components/build/Show/pages/summary/EmptyStates/ViewNotAvailable";
import { useSteps } from "~/components/build/Show/lib/useSteps";

export default function StepUploads() {
  const { build } = useBuild();
  const { steps } = useSteps();
  const ref = useRef<FrameElement>(null);

  const debouncedReload = debounce(() => {
    ref.current?.reload();
  }, 1000);

  useEffect(() => {
    if (!Features.DisableSummaryStepUploadsView) {
      debouncedReload();
    }
  }, [steps.length]); // eslint-disable-line react-hooks/exhaustive-deps

  if (Features.DisableSummaryStepUploadsView) {
    return <ViewNotAvailable />;
  }

  return (
    <div data-turbo={true}>
      <turbo-frame id="step_uploads" src={`${build.path}/step-uploads`} ref={ref}>
        <div className="p-3 text-center">
          <Spinner />
        </div>
      </turbo-frame>
    </div>
  );
}
